"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmrAccordion = void 0;
// packages
const react_1 = __importStar(require("react"));
// styles
const Accordion_styles_1 = require("./Accordion.styles");
exports.SmrAccordion = ({ isVisible = true, items, noGutter = false, width, hideCollapsedIcon = false, initExpandedIndex, }) => {
    const [itemOpen, setItemOpen] = react_1.useState(initExpandedIndex || undefined);
    const handleOnClick = (index, cb, keepExpanded) => {
        // If ExpandableCard must be keepExpanded avoid any other interaction with controls
        if (keepExpanded) {
            if (cb) {
                cb();
            }
            return;
        }
        // Handle onClick callback
        if (cb) {
            cb();
        }
        if (index === itemOpen) {
            setItemOpen(undefined);
            return;
        }
        setItemOpen(index);
    };
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, items.map((item, index) => (react_1.default.createElement(Accordion_styles_1.ExpandableCardStyled, { badgeColor: item === null || item === void 0 ? void 0 : item.badgeColor, badgeCount: (item === null || item === void 0 ? void 0 : item.badgeCount) || index + 1, collapsedIcon: item === null || item === void 0 ? void 0 : item.collapsedIcon, detailsColor: item === null || item === void 0 ? void 0 : item.detailsColor, detailsHeight: item === null || item === void 0 ? void 0 : item.detailsHeight, detailsStatus: item === null || item === void 0 ? void 0 : item.detailsStatus, expandedIcon: item === null || item === void 0 ? void 0 : item.expandedIcon, hideCollapsedIcon: hideCollapsedIcon, expanded: itemOpen == index, hasBadge: Object.prototype.hasOwnProperty.call(item, 'hasBadge')
            ? item.hasBadge
            : true, icon: item === null || item === void 0 ? void 0 : item.icon, iconSize: item === null || item === void 0 ? void 0 : item.iconSize, isVisible: item === null || item === void 0 ? void 0 : item.isVisible, keepExpanded: item === null || item === void 0 ? void 0 : item.keepExpanded, key: index, noGutter: noGutter, onClick: () => handleOnClick(index, item === null || item === void 0 ? void 0 : item.onClick, item === null || item === void 0 ? void 0 : item.keepExpanded), status: item === null || item === void 0 ? void 0 : item.status, summaryColor: item === null || item === void 0 ? void 0 : item.summaryColor, summaryHeight: item === null || item === void 0 ? void 0 : item.summaryHeight, summaryStatus: item === null || item === void 0 ? void 0 : item.summaryStatus, width: width || item.width },
        react_1.default.createElement(Accordion_styles_1.ExpandableCardStyled.Summary, null, item.summary),
        react_1.default.createElement(Accordion_styles_1.ExpandableCardStyled.Details, null, item.details))))));
};
exports.default = exports.SmrAccordion;
//# sourceMappingURL=Accordion.js.map